import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import { calculateDuration } from 'modules/attendance/lib/calculateDuration'
import { renderChange } from 'modules/attendance/lib/editTimesheetRequestsDisplay'
import { locationTypeText } from 'modules/attendance/lib/locationType'

interface CreateShiftBlockProps {
  minutes: number
  clockIn: string | undefined
  clockOut: string | undefined
  employeeName: string
  date: string
  locationType?: string
  observations?: string
  newIsBreak: boolean
  newBreakName?: string
  newBreakPaid?: boolean
}

const CreateShiftBlock = ({
  minutes,
  clockIn,
  clockOut,
  employeeName,
  date,
  newIsBreak = false,
  newBreakName,
  newBreakPaid,
  locationType,
  observations,
}: CreateShiftBlockProps) => {
  const clockInTime = clockIn ?? ''
  const clockOutTime = clockOut ?? ''
  const shiftDuration = calculateDuration(clockInTime, clockOutTime)
  const workedTime = minutesToText(minutes)

  return (
    <>
      <Box paddingLeft="s16">
        <ul>
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.clock_in'),
            'grey1000',
            '',
            clockInTime
          )}
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.clock_out'),
            'grey1000',
            '',
            clockOutTime
          )}
          {locationType &&
            renderChange(
              i18n.t('dashboard.todo.approvals.attendance.location_type'),
              'grey1000',
              '',
              locationTypeText(locationType)
            )}
          {newIsBreak && (
            <li key={'break'} style={{ listStyleType: 'disc' }}>
              <Text.Normal weight="bold">
                {i18n.t('dashboard.todo.approvals.attendance.break')}
              </Text.Normal>
              <Box width="fit-content" padding="s4">
                <Tag type={newBreakPaid ? Tag.Types.lime : Tag.Types.malibu}>{newBreakName}</Tag>
              </Box>
            </li>
          )}
          {observations &&
            renderChange(
              i18n.t('dashboard.todo.approvals.attendance.observations'),
              'grey1000',
              '',
              observations
            )}
        </ul>
      </Box>

      <Box
        background="viridian200"
        paddingX="s16"
        paddingY="s24"
        borderRadius={{ all: 'abs012' }}
        gap="s8"
      >
        <Text size="200">
          {i18n.t('dashboard.todo.approvals.attendance.new_shift', {
            employee: employeeName ?? '',
            date: dateToString(moment(date ? String(date) : ''), 'ui_abbreviated_month_year'),
            duration_hours: shiftDuration.hours,
            duration_minutes: shiftDuration.minutes,
          })}
        </Text>
        <Text size="200">
          {i18n.t('dashboard.todo.approvals.attendance.worked_time', { workedTime })}
        </Text>
      </Box>
    </>
  )
}

export default CreateShiftBlock
